import { render, staticRenderFns } from "./ProjectDetailsDialog.vue?vue&type=template&id=a07cbd3c&scoped=true"
import script from "./ProjectDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsDialog.vue?vue&type=style&index=0&id=a07cbd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07cbd3c",
  null
  
)

export default component.exports